import AbstractController from '../src/services/ControllersRepository/AbstractController';
import ChecklistCreateForm from '@views/checklists/ChecklistCreateForm';
import ChecklistUpdateForm from '@views/checklists/ChecklistUpdateForm';

export default class Checklists extends AbstractController {
    protected controllerName = 'Checklists';

    protected getDefaultCreateFormComponent() {
        return ChecklistCreateForm;
    }

    protected getDefaultUpdateFormComponent() {
        return ChecklistUpdateForm;
    }
}
